// function initTableSort($el) {

//   var toggler = true;

//   // trigger table sort
//   $el.on('click', function (e) {
//     e.preventDefault();

//     var tar = $el.attr('href').substring(1);
//     var col = $el.closest('tr').find('th').index($el.closest('th'));

//     // toggle sort direction
//     if (toggler) {
//       sortTable(tar, col, 'dsc');
//       $el.addClass('is-dsc').removeClass('is-asc');
//     } else {
//       sortTable(tar, col, 'asc');
//       $el.addClass('is-asc').removeClass('is-dsc');
//     }

//     toggler = !toggler;
//   });


//   function sortTable(tar, col, dir) {
//     var table, rows, switching, i, x, y, shouldSwitch;
//     table = document.getElementById(tar);
//     switching = true;

//     while (switching) {

//       switching = false;
//       rows = table.rows;

//       /* Loop through all table rows (except the
//       first, which contains table headers): */
//       for (i = 1; i < (rows.length - 1); i++) {

//         shouldSwitch = false;

//         x = rows[i].getElementsByTagName("TD")[col];
//         y = rows[i + 1].getElementsByTagName("TD")[col];

//         // sort direction
//         if (dir === 'asc') {

//           // Check if the two rows should switch place:
//           if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
//             shouldSwitch = true;
//             break;
//           }

//         } else if (dir === 'dsc') {

//           // Check if the two rows should switch place:
//           if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
//             shouldSwitch = true;
//             break;
//           }

//         }

//       }
//       if (shouldSwitch) {
//         rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
//         switching = true;
//       }
//     }
//   }


// }
// window.initTableSort = initTableSort; // make globally accessible


// function swipeAwayTrayModal(container) {
//   container.addEventListener("touchstart", startTouch, false);
//   container.addEventListener("touchmove", moveTouch, false);

//   var initialY = null;

//   function startTouch(e) {  
//     initialY = e.touches[0].clientY;
//   };

//   function moveTouch(e) {

//     if (initialY === null) {
//       return;
//     }

//     var currentY = e.touches[0].clientY;
//     var diffY = initialY - currentY;

//       if (diffY < 0) {
//         // swiped down, close modal
//         $(container).closest('.modal').modal('hide');
//       } 

//     initialY = null;

//     e.preventDefault();
//   };
// }


function initPasswordToggle() {
  $(document).on('click', '[data-toggle="password"]', function (e) {
    e.preventDefault();

    var $trigger = $(this);
    var input = $trigger.closest('.input-group').find('input.form-control')[0];

    if (input.type === "password") {
      input.type = "text";
      $trigger.find('.icon use').attr('xlink:href', '#eye-off');
    } else {
      input.type = "password";
      $trigger.find('.icon use').attr('xlink:href', '#eye');
    }

    $(input).focus();

  });

}

function isInt(value) {
  return !isNaN(value) &&
    parseInt(Number(value)) == value &&
    !isNaN(parseInt(value, 10));
}

function initCustomOTP() {

  // on code keyup...
  $(document).on('input', '.custom-otp__inputs input', function () {
    var el = $(this),
      val = el.val();
    if (isInt(val)) el.next('input').focus();
  });
}
window.initCustomOTP = initCustomOTP; // make globally accessible

function initCustomOdometer() {

  // on code keyup...
  $(document).on('input', '.custom-odometer__inputs input', function () {
    var el = $(this),
      val = el.val();
    if (isInt(val)) el.next('input').focus();
  });
}
window.initCustomOdometer = initCustomOdometer; // make globally accessible

// function initPausedListClamp() {

//   $('.paused-list').each(function () {

//     // ensure only init once
//     if (!$(this).data('init')) {
//       $(this).data('init', true);

//       var $listContainer = $(this);
//       var LIST_EXPANDER_WIDTH = 60;

//       function resetPausedList() {
//         $listContainer.removeClass('is-expanded');
//         $listContainer.find('li.is-expander').remove();
//         $listContainer.find('li').show();
//         clampPausedList();
//       }

//       function clampPausedList() {
//         var LIST_WIDTH = $listContainer.width();
//         var SCREEN_WIDTH = $(window).width();
//         var MOBILE = (SCREEN_WIDTH < 992);

//         if (MOBILE)
//           var $listItems = $listContainer.find('li');
//         else
//           var $listItems = $listContainer.find('small, li');

//         var totalItems = $listItems.length;
//         var totalWidth = 0;
//         var countItems = 0;

//         while (totalWidth < LIST_WIDTH - LIST_EXPANDER_WIDTH) {
//           totalWidth += $listItems.eq(countItems).outerWidth(true);
//           countItems++;
//         }

//         // looped until navbar-claim__feed many to fit, let's subtract the last
//         var maxItems = countItems - 1;

//         // clamp
//         if (maxItems < totalItems) {

//           $listItems.slice(maxItems).hide();
//           $listContainer.find('ul').append('<li class="is-expander"><strong class="tag-pill tag-pill--lg tag-pill--paused">+ ' + (totalItems - maxItems) + '</strong></li>');

//           // expand click listener
//           $listContainer.off('click').on('click', 'li.is-expander', function () {

//             var $trigger = $(this);

//             if ($trigger.hasClass('show')) {
//               resetPausedList();
//             } else {
//               $trigger.addClass('show').find('strong').text('Hide');
//               $listContainer.addClass('is-expanded');
//               $listItems.show();
//             }


//           })

//         }

//       }

//       clampPausedList();
//       $(window).on('resize orientationchange', function () {
//         resetPausedList();
//       })


//     }

//   });
// }




function initPolicyFeed() {

  $(document).on('click', '#policy-feed-trigger', function (e) {
    e.preventDefault();
    var $trigger = $(this);

    $trigger.toggleClass('is-active');

    var $tar = $($trigger.attr('href'));
    $tar.toggleClass('policy-feed-active');
  });

}

function policyFeedScrollToSelected($el) {
  var $mobileScrollArea = $('.modal-policy-feed__inner');

  $mobileScrollArea.stop().animate({
    scrollTop: $el.position().top - 100
  }, 350);

  var $scrollArea = $('.policy-feed__inner');
  $scrollArea.animate({
    scrollTop: $el.position().top + $scrollArea.scrollTop() - 20
  }, 350);
}

function initClaimFeed() {
  $(document).on('click', '#claim-feed-trigger', function (e) {
    e.preventDefault();
    var $trigger = $(this);

    $trigger.toggleClass('is-active');

    var $tar = $($trigger.attr('href'));
    $tar.toggleClass('claim-feed-active');
  });
}





function initCheckQuoteProgressScroll() {

  function checkQuoteProgressScroll() {
    if ($el.length) {
      if ($el.hasScrollBar()) {
        $el.addClass('has-scroll');
      } else {
        $el.removeClass('has-scroll');
      }
    }
  }

  var $el = $('.quote-progress__content');

  checkQuoteProgressScroll();
  $(window).on('resize orientationchange', checkQuoteProgressScroll);

}


function claimsFeedScrollToSelected($el) {
  var $mobileScrollArea = $('.modal-claimsfeed__content');
  $mobileScrollArea.stop().animate({
    scrollTop: $el.offset().top + $mobileScrollArea.scrollTop() - 100
  }, 350);

  var $scrollArea = $('.claim-progress__content');
  $scrollArea.stop().animate({
    scrollTop: $el.offset().top + $scrollArea.scrollTop() - 100 - 10
  }, 350);
}
window.claimsFeedScrollToSelected = claimsFeedScrollToSelected; // make globally accessible


function initCentralNavScrollTo() {
  $(document).on('click', '.has-scrollto .central-nav__list li a', function (e) {
    e.preventDefault();
    let $this = $(this);

    // if nothing to scroll to, return without error
    let href = $this.attr('href');
    if (href.length < 2 || !$(href).length) return;

    let isDesktop = window.matchMedia('(min-width: 992px)').matches;

    // if has sub item & isDesktop or within a sidesheet, don't follow the anchor link
    if ($this.closest('li').hasClass('has-sub') && (isDesktop || $this.closest('.sidesheet').length)) return;

    let pdfViewCompare = $('body').hasClass('page--pdf-view-compare');
    let offset = isDesktop ? 30 + (pdfViewCompare ? 40 : 0) : $('.layout__sidecol').outerHeight();
   
  
    $('html,body').animate({
      scrollTop: $(href).offset().top - $('.navbar').outerHeight() - offset
    }, 500);
   

  });
}

$(function () {


  // listen for downswipes on tray-type modals (mobile)
  // TO FIX:
  // currently prevents scrolling inside modals, so disabling for now
  // $('.modal-traymenu').each(function () {
  //   swipeAwayTrayModal(this)
  // });

  initPasswordToggle();
  initCustomOTP();
  initCustomOdometer();
  // initPausedListClamp();
  initPolicyFeed();
  initClaimFeed();
  initCentralNavScrollTo();


});